'use client';

import React, { Suspense, lazy } from 'react';

// PERFORMANCE: Lazy load react-markdown to prevent it from being included in initial bundle
// This saves ~6KB of JS and removes mdast-util, hast-util, unified from initial load
const MarkdownRendererLazy = lazy(() =>
  import('./MarkdownRenderer').then((mod) => ({ default: mod.MarkdownRenderer }))
);

interface LazyMarkdownRendererProps {
  content?: string;
  className?: string;
}

// Simple loading placeholder
const LoadingPlaceholder = ({ className }: { className?: string }) => (
  <div className={`animate-pulse ${className || ''}`}>
    <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
    <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
    <div className="h-4 bg-gray-200 rounded w-5/6"></div>
  </div>
);

export function LazyMarkdownRenderer({ content, className = '' }: LazyMarkdownRendererProps) {
  if (!content) {
    return null;
  }

  return (
    <Suspense fallback={<LoadingPlaceholder className={className} />}>
      <MarkdownRendererLazy content={content} className={className} />
    </Suspense>
  );
}

export default LazyMarkdownRenderer;

